import { EventEmitterInterface } from 'pf-frontend-common/src/module/event/emitter.interface';

import { configGetLanguage } from 'common/helper/config/get-language';
import { functionNoop } from 'common/helper/function/noop';
import { DataStore } from 'common/module/data/store';
import { DataStoreEvent } from 'common/module/data/store.event';
import { ImageGalleryTemplatePropsInterface } from 'common/module/image-gallery/template-props.interface';
import { ImageGalleryViewStore } from 'common/module/image-gallery/view-store';

import { GalleryScrollComponentPropsInterface } from './component-props.interface';

export class GalleryScrollViewStore extends DataStore {
  /**
   * @inheritdoc
   */
  protected state: ImageGalleryTemplatePropsInterface;

  /**
   * Constructor
   */
  constructor(eventEmitter: EventEmitterInterface, private imageGalleryViewStore: ImageGalleryViewStore) {
    super(eventEmitter);
  }

  /**
   * @inheritDoc
   */
  public initialize(options: GalleryScrollComponentPropsInterface): void {
    const { items, onClick, onIndexChange, onScroll = functionNoop } = options;

    if (!items.length) {
      return;
    }

    this.imageGalleryViewStore.initialize({
      items,
      isRtl: configGetLanguage().isRtl,
      onGalleryScroll: onScroll,
      feature: {
        showAll: true,
        thumbnails: false,
        singleImagePreview: true,
      },
      onIndexChange,
      onGalleryClick: onClick,
    });

    this.calculateState();
    this.observers();
  }

  /**
   * Attach listeners
   */
  public observers(): void {
    this.imageGalleryViewStore
      .getEventEmitter()
      .addListener(DataStoreEvent.updateState, this.onUpdateStateGalleryStore);
  }

  /**
   * @inheritdoc
   */
  public destroy(): void {
    this.imageGalleryViewStore
      .getEventEmitter()
      .removeListener(DataStoreEvent.updateState, this.onUpdateStateGalleryStore);

    this.imageGalleryViewStore.destroy();
  }

  /**
   * @inheritdoc
   */
  public getState(): ImageGalleryTemplatePropsInterface {
    return this.state;
  }

  /**
   * Calculate state
   */
  private calculateState(): void {
    this.setState({
      ...this.imageGalleryViewStore.getState(),
    });
  }

  /**
   * Parent gallery state updated
   */
  private onUpdateStateGalleryStore = () => {
    this.calculateState();
  };
}
